import styled from 'styled-components';
export var Inner = styled.div.withConfig({
  displayName: "partials__Inner",
  componentId: "sc-lok6o-0"
})(["> div{max-width:320px;margin:0 auto 30px;}"]);